/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import FileSaver from "file-saver";
import gfm from "remark-gfm";
import ReactMarkdown from "react-markdown";
import moment from "moment/moment";
import Select from "react-select";
import { v4 as uuidv4 } from "uuid";

import { Worker } from "@react-pdf-viewer/core";
import { toolbarPlugin } from "@react-pdf-viewer/toolbar";
// Core viewer
import { Viewer } from "@react-pdf-viewer/core";

import { getSite } from "../features/chatbot/getSiteDataSlice";
import { sendQuestion } from "../features/chatbot/sendQuestionSlice";

import LeftSidebar from "../layout/ChatBotSidebar";

import ChatPageFooter from "./ChatPageFooter";

import { SocketContext } from "../socket/socket";

import importAll from "../components/chat-component/images";
import { OK } from "../constants/statusCode";

import { sendReactionValue } from "../features/chatbot/sendReactionValueSlice";
import { getRandomText, setandgetCookies } from "../utils/utils";
import ShareDocumentModal from "../components/chat-component/modal/ShareDocumentModal";

import { sendShareDocumentSettings } from "../features/chatbot/sendShareDocumentSettings";
import { resetSite } from "../features/chatbot/resetSiteDataSlice";

// import FilterComponent from "../common/filter";
import { getConversations } from "../features/chatbot/getConversationsSlice";
import { getLabels } from "../features/chatbot/labelListSlice";
import { getParticularConversation } from "../features/chatbot/getParticularConversationSlice";
import { getDocumentLabelListOfInviteOnlyUsers } from "../features/chatbot/getDocumentLabelListOfInviteOnlyUsersSlice";
import Loader from "../common/loader/Loader";
import { updateConversation } from "../features/chatbot/updateConversationSlice";

const images = importAll(
  require.context("../assets/images/", false, /\.(png|jpe?g|svg|GIF|webp)$/)
);

const preprocessMarkdown = (source) => {
  // Replace single newline characters with React line break elements
  if (source) {
    return source.replace(/\n/g, "  \n");
  }
};

const ChatPage = () => {
  const dispatch = useDispatch();

  const [show, setShow] = useState("");

  const [referenceDocument, setReferenceDocument] = useState("");

  const socketContext = useContext(SocketContext);

  const [basePromptValue, setBasePromptValue] = useState(
    'You are an AI assistant in a conversation with a human.\nAnswer their questions as truthfully as possible using the provided text.If the answer is not contained within the text, say "Hmm, I am not sure". Reply in the same language as the question.'
  );
  const [basePrompt, setBasePrompt] = useState({});
  const [selectedTone, setSelectedTone] = useState({});

  const [initialMessage, setInitialMessage] = useState(
    "Hi! What can I help you with?"
  );

  const [oldConversationInitialMessage, setOldConversationInitialMessage] =
    useState("Hi! What can I help you with?");

  const [documentPageNumber, setDocumentPageNumber] = useState(0);

  const { siteData } = useSelector((state) => state.getSiteData);

  const { particularConversationData } = useSelector(
    (state) => state.getParticularConversationData
  );

  const [documentLink, setDocumentLink] = useState(false);

  const [documentType, setDocumentType] = useState("");

  const [html, setHtml] = useState(null);

  const [contentFromSearch, setContentFromSearch] = useState("All documents");

  const target = useRef(null);

  const [source, setSource] = useState(true);

  const [loadingPropmptData, setLoadingPromptData] = useState([]);

  const [exportJSONLoadingPromptData, setExportJSONLoadingPromptData] =
    useState([]);

  const [lengthValue, setLengthValue] = useState("Detailed");
  const [likeValue, setLikedValue] = useState(false);

  const [switchChange, handleSwitchChange] = useState(false);

  const [selectedOptions, setSelectedOptions] = useState([]);

  const [selectedLabelOptions, setSelectedLabelOptions] = useState([]);

  const [responseTone, setResponseTone] = useState("Conversational");

  const [typeOfAnswer, setTypeOfAnswer] = useState("ai_driven_answer");

  const [selectedLabel, setSelectedLabel] = useState("all labels");

  const [selectedDocument, setSelectedDocument] = useState("all documents");

  const [selectedConversation, setSelectedConversation] = useState("");

  const [roleValue, setRoleValue] = useState("");

  const [selectedConversationName, setSelectedConversationName] = useState("");

  let loading = useRef("");

  const [inputedQuestion, setInputtedQuestion] = useState("");
  const [showModal, setShowModal] = useState(false);

  const { pathname, search } = useLocation();
  const demo = pathname.split("/").pop();

  const searchParams = new URLSearchParams(search);
  var location = searchParams.get("debug");

  const bottom = useRef(null);

  const scrollToBottom = () => {
    bottom?.current?.scrollIntoView({ behavior: "smooth" });
  };

  const toolbarPluginInstance = toolbarPlugin();
  const { Toolbar } = toolbarPluginInstance;

  const [toolTipToggle, handleTooltipToggle] = useState(false);

  let payloadData = useRef({ name: "", filter: [], conversationId: "" });

  const filterMenu = [
    {
      id: "filterby",
      label: "Filter by",
    },
    {
      id: "document",
      label: "Documents",
    },
    {
      id: "label",
      label: "Labels",
    },
  ];

  let filterOptions = filterMenu?.map((el) => {
    return {
      name: el.id,
      label: el.label,
      key: el.id,
    };
  });

  const [filterOption, setFilterOption] = useState(filterOptions);

  const [selectedFilter, setSelectedFilter] = useState([]);

  // For Temprature
  const [sliderValue, setSliderValue] = useState(0.2);

  const [modelValue, setModelValue] = useState({
    value: "gpt-3.5-turbo",
    label: "GPT-3.5 Turbo",
  });

  const CopyDataToClipboard = (markdownContent) => {
    var range = document.createRange();
    range.selectNode(document.getElementById(markdownContent));
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    document.execCommand("copy");
    window.getSelection()?.removeRange(range);
  };

  useEffect(() => {
    socketContext.initiateConnection();
    setandgetCookies();
    dispatch(getSite(demo));
    dispatch(getConversations(demo));
    dispatch(getLabels(demo));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setShow("");
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  useEffect(() => {
    const fetchHtml = async () => {
      if (referenceDocument !== "") {
        const response = await fetch(referenceDocument);
        const htmlContent = await response.text();
        setHtml(htmlContent);
      }
    };

    fetchHtml();
  }, [referenceDocument]);

  const UpdateData = async (personaUUID,toneUUID) => {
    if (selectedConversation) {
      const { payload } = await dispatch(
        updateConversation({
          conversationId: selectedConversation,
          settings: {
            personaUUID: personaUUID,
            toneUUID: toneUUID,
          },
        })
      );
    }
  };



  useEffect(() => {
    if (siteData?.details?.is_public === 4) {
      dispatch(getDocumentLabelListOfInviteOnlyUsers(demo));
    }
    if (siteData?.details?.project_setting) {
      setDocumentLink(siteData?.details.is_public === 1 ? true : false);
      handleTooltipToggle(siteData?.details?.project_setting?.tooltip_toggle);
      setLengthValue(siteData?.details?.project_setting?.answer_symantic);
      setTypeOfAnswer(siteData?.details?.project_setting?.answer_type);
      setResponseTone(siteData?.details?.project_setting?.tone);
      setSource(
        siteData?.details?.project_setting?.wants_source === 1 ? true : false
      );
      setRoleValue(siteData?.details.project_setting?.role_value);
      handleSwitchChange(siteData?.details?.project_setting?.debug_switch);
      setSliderValue(siteData?.details?.project_setting?.temprature ?? 0.2);
      const modelLabel =
        siteData?.details?.project_setting?.model === "gpt-4"
          ? "GPT-4"
          : "GPT-3.5 Turbo";
      setModelValue({
        value: siteData?.details?.project_setting?.model,
        label: modelLabel,
      });
      if (
        siteData?.details?.project_setting?.initial_message !== "" &&
        siteData?.details?.project_setting?.initial_message !== undefined &&
        siteData?.details?.project_setting?.initial_message !== null
      ) {
        setInitialMessage(siteData?.details?.project_setting?.initial_message);
      } else {
        setInitialMessage("Hi! What can I help you with?");
      }
    }
  }, [siteData]);

  useEffect(() => {
    if (
      particularConversationData?.conversations !== undefined &&
      particularConversationData?.conversations?.length !== 0
    ) {
      setLoadingPromptData([]);
      let filterContent = [];
      let preparedPrompt = "";
      particularConversationData?.conversations?.map((_value, _index) =>
        setLoadingPromptData((value) => {
          filterContent = [];
          if (_value.weaviate_response?.reference_contents.length > 0) {
            _value.weaviate_response?.reference_contents.map((_data, _idx) => {
              filterContent.push(_data);
            });
          }
          const filteredArr = filterContent.filter((item, index) => {
            // check if the index of the first occurrence of the item's name is the same as the current index
            return (
              filterContent.findIndex(
                (obj) => obj.fileName === item.fileName
              ) === index
            );
          });

          let promptDataQuestion = _value.question;
          let preparedPromptData =
            _value.weaviate_response?.preparedPrompt?.replaceAll(/\\n/g, "<br/>") ?? "";
          preparedPromptData =
            _value.weaviate_response?.preparedPrompt?.replaceAll("\n", "<br/>") ?? "";
          return [
            ...value,
            {
              ...{
                questionUUID: _value.questionUUID,
                questionId: _value.uuid,
                question: promptDataQuestion,
                answer: _value.answer,
                like: _value.is_liked,
                optionalAnswer1: _value.weaviate_response
                  ? _value.weaviate_response.reference_contents.length > 0 &&
                    filteredArr
                  : false,
                referenceFiles:
                  _value.weaviate_response &&
                  _value.weaviate_response.referenceFiles.length > 0 &&
                  _value.weaviate_response.referenceFiles,
                preparedPrompt: preparedPromptData,
              },
              ..._value.weaviate_response,
              conversation: {
                uuid: _value.uuid,
              },
            },
          ];
        })
      );
    } else {
      setLoadingPromptData([]);
    }
  }, [particularConversationData]);
  useEffect(() => {
    // scrollToBottom();
    if (inputedQuestion === "" && !likeValue) {
      bottom?.current?.scrollIntoView({ behavior: "instant", block: "end" });
    } else {
      setLikedValue(false);
    }
  }, [loadingPropmptData]);

  useEffect(() => {
    // Listen for socket events and update state accordingly
    const handleSocketResponse = (res) => {
      // Update loadingPromptData or other state as needed
      console.log("STREAMING TEXT 1", res);
      if (loadingPropmptData && loadingPropmptData.length > 0) {
        setLoadingPromptData((previousMessages) => {
          let otherMessages = previousMessages.filter((message) => {
            return message.questionUUID !== res.questionUUID;
          });

          let matchedMessage = previousMessages.find((message) => {
            return message.questionUUID === res.questionUUID;
          });

          console.log(matchedMessage, "MATCHED MESSAGES", otherMessages);
          if (matchedMessage) {
            matchedMessage.answer += res.text;
            matchedMessage.loading = false;
          }

          if (matchedMessage === undefined) {
            return otherMessages;
          }

          return [...otherMessages, ...(matchedMessage && [matchedMessage])];
        });
      }
    };

    //Listen for socket events in failure response
    const handleSocketFailedResponse = (res) => {
      console.log(res, "FAILURE RESPONSE");
      if (loadingPropmptData && loadingPropmptData.length > 0) {
        setLoadingPromptData((previousMessages) => {
          let otherMessages = previousMessages.filter((message) => {
            return message.questionUUID !== res.questionUUID;
          });

          let matchedMessage = previousMessages.find((message) => {
            return message.questionUUID === res.questionUUID;
          });
          if (matchedMessage) {
            matchedMessage.errorData = matchedMessage.answer;
            matchedMessage.loading = false;
          }

          if (matchedMessage === undefined) {
            return otherMessages;
          }

          return [...otherMessages, ...(matchedMessage && [matchedMessage])];
        });
      }
    };

    socketContext?.socket?.on("broadcast-response", handleSocketResponse);

    socketContext?.socket?.on(
      "broadcast-response-failed",
      handleSocketFailedResponse
    );

    return () => {
      // Cleanup the socket event listener when the component unmounts
      socketContext?.socket?.off("broadcast-response", handleSocketResponse);
    };
  }, [socketContext, loadingPropmptData, selectedConversation]);

  useEffect(() => {
    if (basePrompt?.prompt) {
      setBasePromptValue(basePrompt.prompt);
    }
  }, [basePrompt]);

  const handleFaqSend = async (setKeyPressed, isFromRegenerate = false) => {
    const generateQuestionUUID = uuidv4();
    setOldConversationInitialMessage(
      siteData?.details?.project_setting?.initial_message
    );
    setReferenceDocument("");
    scrollToBottom();
    console.log(loadingPropmptData, "PROMPT DATA");
    setLoadingPromptData([
      ...loadingPropmptData,
      {
        questionUUID: generateQuestionUUID,
        question: isFromRegenerate
          ? loadingPropmptData[loadingPropmptData.length - 1].question
          : inputedQuestion.trim(),
        answer: "",
        loading: true,
      },
    ]);
    setExportJSONLoadingPromptData([
      ...exportJSONLoadingPromptData,
      {
        question: isFromRegenerate
          ? loadingPropmptData[loadingPropmptData.length - 1].question
          : inputedQuestion.trim(),
        answer: "",
        loading: true,
      },
    ]);
    loading.current = true;
    setInputtedQuestion("");
    let values = {
      questionUUID: generateQuestionUUID,
      prompt: isFromRegenerate
        ? loadingPropmptData[loadingPropmptData.length - 1].question
        : inputedQuestion.trim(),
      answer_type: typeOfAnswer,
      answer_symantic: lengthValue.toLowerCase(),
      wants_source: source,
      project_slug: demo,
      act_as: roleValue,
      conversation_uuid: selectedConversation ? selectedConversation : null,
      filter:
        payloadData.current.filter.length > 0
          ? payloadData.current.filter
          : null,
      // personaText: basePrompt?.prompt ?? "",
      personaText: basePromptValue,
      personaUUID: basePrompt?.uuid ?? "",
      toneUUID: selectedTone.uuid,
    };
    responseTone !== "" && (values.tone = responseTone.toLowerCase());
    const faqData = await dispatch(
      sendQuestion({
        values: values,
        projectName: demo,
      })
    );
    loading.current = false;

    if (faqData?.payload?.status === OK) {
      let finalData = "";
      let optionalAnswer1 = "";
      let filterContent = [];
      let filteredArr = [];
      let promptAnswer = "";
      let preparedPrompt = "";
      /*    if (
        faqData?.payload.data.data.prompt_answer === "" ||
        faqData?.payload.data.data.prompt_answer === null
      ) {
        finalData =
          "I'm sorry, I don't have an answer for that at the moment. Is there anything else I can help you with?";
      } else { */
      finalData = faqData?.payload?.data?.data?.prompt_answer;
      if (faqData?.payload?.data?.data?.reference_contents.length > 0) {
        faqData?.payload?.data?.data?.reference_contents.map((_data, _idx) => {
          filterContent.push(_data);
        });
        filteredArr = filterContent.filter((item, index) => {
          // check if the index of the first occurrence of the item's name is the same as the current index
          return (
            filterContent.findIndex((obj) => obj.fileName === item.fileName) ===
            index
          );
        });
      }
      promptAnswer = faqData?.payload?.data?.data?.prompt_answer;
      preparedPrompt = faqData?.payload?.data?.data?.preparedPrompt;
      preparedPrompt = faqData?.payload?.data?.data?.preparedPrompt;
      // }

      setLoadingPromptData((previousMessages) => {
        let messages = previousMessages.map((message) => {
          const answer = message?.answer ?? finalData;
          console.log(message.answer, "ANSWER MESSAGE", finalData);
          if (
            message.questionUUID === faqData?.payload?.data?.data?.questionUUID
          ) {
            message = {
              ...message,
              questionUUID: faqData?.payload?.data?.data?.questionUUID,
              questionId: faqData?.payload?.data?.data?.conversation?.uuid,
              question: isFromRegenerate
                ? loadingPropmptData[loadingPropmptData.length - 1].question
                : inputedQuestion.trim(),
              answer: answer,
              optionalAnswer1:
                faqData?.payload?.data?.data?.reference_contents.length > 0 &&
                filteredArr,
              referenceFiles:
                faqData?.payload?.data?.data?.referenceFiles.length > 0 &&
                faqData?.payload?.data?.data?.referenceFiles,
              prompt_answer: answer,
              preparedPrompt: preparedPrompt,
              loading: false,
              errorData: message?.errorData ?? message?.errorData,
            };
          }
          return message;
        });
        console.log(messages, "MESSAGES");
        return messages;
      });
      setExportJSONLoadingPromptData([
        ...exportJSONLoadingPromptData,
        {
          question: isFromRegenerate
            ? loadingPropmptData[loadingPropmptData.length - 1].question
            : inputedQuestion,
          answer: finalData,
          loading: false,
          prompt_answer: promptAnswer,
        },
      ]);
      if (selectedConversation === "") {
        const conversationData = await dispatch(getConversations(demo));

        setSelectedConversation(
          conversationData.payload.data.responseData.userConversations[0].uuid
        );
        setSelectedConversationName(
          conversationData.payload.data.responseData.userConversations[0].name
        );
        // await dispatch(
        //   getParticularConversation(
        //     conversationData.payload.data.responseData.userConversations[0].uuid
        //   )
        // );
      }
    } else {
      setLoadingPromptData([
        ...loadingPropmptData,
        {
          questionUUID: generateQuestionUUID,
          question: isFromRegenerate
            ? loadingPropmptData[loadingPropmptData.length - 1].question
            : inputedQuestion.trim(),
          answer: "",
          loading: false,
          errorData: faqData?.payload?.response?.data?.message,
        },
      ]);
      setExportJSONLoadingPromptData([
        ...exportJSONLoadingPromptData,
        {
          question: isFromRegenerate
            ? loadingPropmptData[loadingPropmptData.length - 1].question
            : inputedQuestion.trim(),
          answer: "",
          loading: false,
          errorData: faqData?.payload?.response?.data?.message,
        },
      ]);
    }
    setInputtedQuestion("");
    scrollToBottom();
    if (setKeyPressed !== undefined && setKeyPressed !== "") {
      setKeyPressed(false);
    }
  };

  const handleAnswerResponse = async (questionId, _response) => {
    setLikedValue(true);
    const response = await dispatch(
      sendReactionValue({
        questionId: questionId,
        _response: _response,
      })
    );
    if (response?.payload?.status === OK) {
      setLoadingPromptData((prevState) =>
        prevState.map((item, index) => {
          if (item.questionId === questionId) {
            return { ...item, like: _response };
          }
          return item;
        })
      );
    }
  };

  const resetSiteData = async () => {
    if (loadingPropmptData.length > 0) {
      const { payload } = await dispatch(
        resetSite({ siteKey: demo, threadKey: selectedConversation })
      );
      if (payload.status === OK) {
        setLoadingPromptData([]);
      }
    }
  };

  const exportText = () => {
    if (loadingPropmptData.length > 0) {
      let text = "";
      loadingPropmptData.forEach((data) => {
        text += `Question: ${data.question}\nAnswer:${data.answer}\n\n`;
      });
      const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
      FileSaver.saveAs(
        blob,
        `${
          JSON.parse(localStorage.getItem("_user"))["projects"][0]["name"]
        }-${moment().format("DD.MM.YYYY-h.mm.ss a")}.txt`
      );
    }
  };

  const exportMarkup = () => {
    if (loadingPropmptData.length > 0) {
      let markup = `
    <html>
      <head>
        <title>${
          JSON.parse(localStorage.getItem("_user"))["projects"][0]["name"]
        }</title>
      </head>
      <body>
        <h3>${
          JSON.parse(localStorage.getItem("_user"))["projects"][0]["name"]
        }</h3>
  `;
      loadingPropmptData.forEach((data) => {
        markup += `
        <h4>Question: ${data.question}</h4>
        <p>Answer: ${escapeHTML(data.answer)}</p>
    `;
      });
      markup += `
      </body>
    </html>
  `;
      const blob = new Blob([markup], { type: "text/html;charset=utf-8" });
      FileSaver.saveAs(
        blob,
        `${
          JSON.parse(localStorage.getItem("_user"))["projects"][0]["name"]
        }-${moment().format("DD.MM.YYYY-h.mm.ss a")}.html`
      );
    }
  };

  // Function to escape special characters for HTML
  function escapeHTML(html) {
    const escapeEl = document.createElement("div");

    escapeEl.innerText = html;
    return escapeEl.innerHTML;
  }

  const exportJson = () => {
    if (loadingPropmptData.length > 0) {
      const blob = new Blob(
        [
          JSON.stringify(
            location === "true" || switchChange
              ? loadingPropmptData
              : exportJSONLoadingPromptData
          ),
        ],
        {
          type: "application/json;charset=utf-8",
        }
      );
      FileSaver.saveAs(
        blob,
        `${
          JSON.parse(localStorage.getItem("_user"))["projects"][0]["name"]
        }-${moment().format("DD.MM.YYYY-h.mm.ss a")}.json`
      );
    }
  };

  /* const saveSettingsData = async () => {
    const values = {
      wants_source: source === true ? 1 : 0,
      answer_type: typeOfAnswer,
      answer_symantic: lengthValue,
      tone: responseTone,
      role_value: roleValue,
      tooltip_toggle: toolTipToggle,
    };
    await dispatch(
      sendShareDocumentSettings({
        values: values,
        project_slug_name: demo,
      })
    );
  }; */

  const saveSettingsData = async (values) => {
    values.persona_uuid = basePrompt?.uuid;
    
    await dispatch(
      sendShareDocumentSettings({
        values: values,
        project_slug_name: demo,
      })
    );
  };

  const setDebugData = (_debugData) => {
    const debugData = _debugData.replace(/\\n/g, "<br/>");
    return debugData;
  };

  const gptModalOptions = [
    {
      value: "gpt-3.5-turbo",
      label: "GPT-3.5 Turbo",
    },
    {
      value: "gpt-4",
      label: "GPT-4",
    },
  ];

  const handleSliderChange = (event) => {
    setSliderValue(parseFloat(event.target.value));
  };

  return (
    <div className="main-wrapper">
      <div className="remove-sidebar">
        {siteData?.length !== 0 && (
          <>
            <div className="dashbord-content">
              <div className="dashbord-content-inner">
                <LeftSidebar
                  contentFromSearch={contentFromSearch}
                  setContentFromSearch={setContentFromSearch}
                  siteData={siteData}
                  setSelectedLabel={setSelectedLabel}
                  selectedLabel={selectedLabel}
                  selectedDocument={selectedDocument}
                  setSelectedDocument={setSelectedDocument}
                  selectedConversation={selectedConversation}
                  setSelectedConversation={setSelectedConversation}
                  projectSlug={demo}
                  setLoadingPromptData={setLoadingPromptData}
                  setSelectedConversationName={setSelectedConversationName}
                  setSelectedOptions={setSelectedOptions}
                  selectedLabelOptions={selectedLabelOptions}
                  setSelectedLabelOptions={setSelectedLabelOptions}
                  setFilterOption={setFilterOption}
                  filterOptions={filterOptions}
                  selectedFilter={selectedFilter}
                  setSelectedFilter={setSelectedFilter}
                  selectedConversationName={selectedConversationName}
                  setOldConversationInitialMessage={
                    setOldConversationInitialMessage
                  }
                />

                <div className="content-right-box">
                  <div className="intro-table-search container-fluid">
                    <div className="row align-items-center py-3">
                      <div className="col-12 col-lg-4 title-left filter-left">
                        {/* this div is for the filter component  icon  */}
                        {/* <div className="text-blueGray-700">
                          <FilterComponent
                            headCells={filterMenu}
                            filterOptions={filterOptions}
                            setFilterOption={setFilterOption}
                            filterOption={filterOption}
                            selectedConversationName={selectedConversationName}
                            selectedConversation={selectedConversation}
                            payloadData={payloadData.current}
                            setSelectedOptions={setSelectedOptions}
                            selectedOptions={selectedOptions}
                            selectedLabelOptions={selectedLabelOptions}
                            setSelectedLabelOptions={setSelectedLabelOptions}
                            selectedFilter={selectedFilter}
                            setSelectedFilter={setSelectedFilter}
                            publicKey={siteData?.details?.is_public}
                          />
                        </div> */}
                        {/*   <h5 className="intro-title chatbot-title">
                          {contentFromSearch}
                        </h5> */}
                      </div>
                      <div className="col-12 col-lg-8 mt-md-0 d-flex justify-content-end align-items-center title-right">
                        <button
                          className="btn btn-primary-md create-doc-btn share-chatbot mt-0 btn-primary-md"
                          onClick={() => setShowModal(true)}
                        >
                          <img
                            alt=""
                            className="chat-btn-icon"
                            src={images["share.svg"]}
                          />
                          <span className="mobile-hide">Share Chatbot</span>
                        </button>
                        {loadingPropmptData.length > 0 && (
                          <button
                            type="button"
                            className="btn btn-danger-md ms-3"
                            onClick={() => {
                              resetSiteData();
                            }}
                          >
                            <img
                              src={images["reset.svg"]}
                              alt=""
                              className="trash-icn me-1"
                            />
                            <span className="mobile-hide">Reset</span>
                          </button>
                        )}
                        {loadingPropmptData.length > 0 && (
                          <div className="dropdown export-dropdown common-dropdown ms-3">
                            <button
                              type="button"
                              className="btn dropdown-toggle"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <img
                                src={images["export.svg"]}
                                alt=""
                                className="btn-space"
                              />
                              <span className="mobile-hide">Export</span>
                              <img src={images["dropdown-arrow.svg"]} alt="" />
                            </button>
                            <ul className="dropdown-menu">
                              <li>
                                <a
                                  className="dropdown-item"
                                  href="#"
                                  onClick={() => exportText()}
                                >
                                  {" "}
                                  Text
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item"
                                  href="#"
                                  onClick={() => exportJson()}
                                >
                                  Json
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item"
                                  href="#"
                                  onClick={() => exportMarkup()}
                                >
                                  {" "}
                                  Markdown
                                </a>
                              </li>
                            </ul>
                          </div>
                        )}
                        <div className="d-flex align-items-center ms-3">
                          <label className="form-label flex-shrink-0 me-2 mb-0">
                            Debug Mode
                          </label>
                          <div className="custom-switch-main m-0">
                            <input
                              type="checkbox"
                              id="debugSwitch"
                              onChange={(e) => {
                                handleSwitchChange(e.target.checked);
                                saveSettingsData({
                                  answer_symantic: lengthValue,
                                  wants_source: source === true ? 1 : 0,
                                  answer_type: typeOfAnswer,
                                  tone: responseTone,
                                  role_value: roleValue,
                                  tooltip_toggle: toolTipToggle,
                                  debug_switch: e.target.checked,
                                  initial_message: initialMessage,
                                  temprature: sliderValue,
                                  model: modelValue.value,
                                });
                              }}
                              checked={switchChange}
                            />
                            <label htmlFor="debugSwitch">Toggle</label>
                          </div>
                        </div>
                        <div className="dropdown setting-sidebar ms-3">
                          <div
                            className="offcanvas offcanvas-end setting-bar edit-setting-sidebar"
                            tabIndex="-1"
                            id="offCanvasSettingsRight"
                            aria-labelledby="offCanvasSettingsRightLabel"
                          >
                            <div className="setting-block edit-chatbot border-bottom-0">
                              <div className="form-group">
                                <div className="row align-items-top my-2">
                                  <div className="col-8">
                                    <h3>Base Prompt</h3>
                                  </div>
                                  {/* <div className="col-4 text-end">
                                    <span
                                      className="info-btn"
                                      onClick={() => {
                                        setBasePromptValue(
                                          'You are an AI assistant in a conversation with a human.\nAnswer their questions as truthfully as possible using the provided text.If the answer is not contained within the text, say "Hmm, I am not sure". Reply in the same language as the question.'
                                        );
                                        saveSettingsData({
                                          answer_symantic: lengthValue,
                                          wants_source: source === true ? 1 : 0,
                                          answer_type: typeOfAnswer,
                                          tone: responseTone,
                                          role_value: roleValue,
                                          tooltip_toggle: toolTipToggle,
                                          debug_switch: switchChange,
                                          prompt_data:
                                            'You are an AI assistant in a conversation with a human.\nAnswer their questions as truthfully as possible using the provided text.If the answer is not contained within the text, say "Hmm, I am not sure". Reply in the same language as the question.',
                                          initial_message: initialMessage,
                                          temprature: sliderValue,
                                          model: modelValue.value,
                                        });
                                      }}
                                    >
                                      Reset
                                    </span>
                                  </div> */}
                                  <div className="col-12">
                                    <textarea
                                      className="form-control"
                                      rows={"1"}
                                      value={basePromptValue}
                                      onBlur={(e) =>
                                        saveSettingsData({
                                          answer_symantic: lengthValue,
                                          wants_source: source === true ? 1 : 0,
                                          answer_type: typeOfAnswer,
                                          tone: responseTone,
                                          role_value: roleValue,
                                          tooltip_toggle: toolTipToggle,
                                          debug_switch: switchChange,
                                          prompt_data: e.target.value,
                                          initial_message: initialMessage,
                                          temprature: sliderValue,
                                          model: modelValue.value,
                                        })
                                      }
                                      onChange={(e) =>
                                        setBasePromptValue(e.target.value)
                                      }
                                    ></textarea>
                                  </div>
                                </div>
                              </div>
                              {/* <div className="form-group mb-0">
                                <div className="row align-items-top my-2">
                                  <div className="col-8">
                                    <h3>Initial Message</h3>
                                  </div>
                                  <div className="col-4 text-end">
                                    <span
                                      className="info-btn"
                                      onClick={() => {
                                        setInitialMessage(
                                          "Hi! What can I help you with?"
                                        );
                                        saveSettingsData({
                                          answer_symantic: lengthValue,
                                          wants_source: source === true ? 1 : 0,
                                          answer_type: typeOfAnswer,
                                          tone: responseTone,
                                          role_value: roleValue,
                                          tooltip_toggle: toolTipToggle,
                                          debug_switch: switchChange,
                                          prompt_data: basePromptValue,
                                          initial_message:
                                            "Hi! What can I help you with?",
                                          temprature: sliderValue,
                                          model: modelValue.value,
                                        });
                                      }}
                                    >
                                      Reset
                                    </span>
                                  </div>
                                  <div className="col-12">
                                    <input
                                      type={"text"}
                                      className="form-control"
                                      onChange={(e) =>
                                        setInitialMessage(e.target.value)
                                      }
                                      value={initialMessage}
                                      onBlur={(e) =>
                                        saveSettingsData({
                                          answer_type: typeOfAnswer,
                                          wants_source: source === true ? 0 : 1,
                                          answer_symantic: lengthValue,
                                          tone: responseTone,
                                          role_value: roleValue,
                                          tooltip_toggle: toolTipToggle,
                                          debug_switch: switchChange,
                                          prompt_data: basePromptValue,
                                          initial_message: e.target.value,
                                          temprature: sliderValue,
                                          model: modelValue.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>
                              </div> */}

                              <div className="form-group d-flex justify-content-between mt-3 setting-modal-parent-attribute">
                                <div className="mt-2 me-2 setting-modal-child-attributes">
                                  <label className="form-label me-2">
                                    Model
                                  </label>
                                  <Select
                                    options={gptModalOptions}
                                    value={modelValue}
                                    onChange={(e) => {
                                      setModelValue(e);
                                      saveSettingsData({
                                        answer_symantic: lengthValue,
                                        wants_source: source === true ? 1 : 0,
                                        answer_type: typeOfAnswer,
                                        tone: responseTone,
                                        role_value: roleValue,
                                        tooltip_toggle: toolTipToggle,
                                        debug_switch: switchChange,
                                        prompt_data: basePromptValue,
                                        initial_message: initialMessage,
                                        temprature: sliderValue,
                                        model: e.value,
                                      });
                                    }}
                                    // classNamePrefix="cmn-control"
                                    isSearchable={false}
                                  />
                                </div>
                                <div className="mb-0 mt-2 me-2 setting-modal-child-attributes">
                                  <label className="form-label">
                                    Temprature {`(${sliderValue.toFixed(1)})`}{" "}
                                  </label>
                                  <button className="tooltip-button bg-transparent border-0">
                                    <img src={images["info.svg"]} alt="" />
                                    <div className="tooltip-div temprature-tooltip-div">
                                      Increasing the value, say to 0.8, will add
                                      more randomness to the output, whereas
                                      reducing it, for example, to 0.2, will
                                      make the output more concentrated.
                                    </div>
                                  </button>
                                  <div className="custom-slider">
                                    <input
                                      type="range"
                                      min="0.1"
                                      max="1"
                                      step="0.1"
                                      value={sliderValue}
                                      className="form-range"
                                      onChange={(e) => {
                                        handleSliderChange(e);
                                        saveSettingsData({
                                          answer_symantic: lengthValue,
                                          wants_source: source === true ? 1 : 0,
                                          answer_type: typeOfAnswer,
                                          tone: responseTone,
                                          role_value: roleValue,
                                          tooltip_toggle: toolTipToggle,
                                          debug_switch: switchChange,
                                          prompt_data: basePromptValue,
                                          initial_message: initialMessage,
                                          temprature: parseFloat(
                                            e.target.value
                                          ),
                                          model: modelValue.value,
                                        });
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="form-group mt-2 me-2 setting-modal-child-attributes">
                                  <label className="form-label w-100">
                                    Debug Mode
                                  </label>
                                  <div className="custom-switch-main flex-shrink-1 m-0">
                                    <input
                                      type="checkbox"
                                      id="debugSwitch"
                                      onChange={(e) => {
                                        handleSwitchChange(e.target.checked);
                                        saveSettingsData({
                                          answer_symantic: lengthValue,
                                          wants_source: source === true ? 1 : 0,
                                          answer_type: typeOfAnswer,
                                          tone: responseTone,
                                          role_value: roleValue,
                                          tooltip_toggle: toolTipToggle,
                                          debug_switch: e.target.checked,
                                          prompt_data: basePromptValue,
                                          initial_message: initialMessage,
                                          temprature: sliderValue,
                                          model: modelValue.value,
                                        });
                                      }}
                                      checked={switchChange}
                                    />
                                    <label htmlFor="debugSwitch">Toggle</label>
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  className="btn btn-primary-md"
                                  data-bs-toggle="offcanvas"
                                  data-bs-target="#offCanvasSettingsRight"
                                  onClick={() =>
                                    saveSettingsData({
                                      answer_symantic: lengthValue,
                                      wants_source: source === true ? 1 : 0,
                                      answer_type: typeOfAnswer,
                                      tone: responseTone,
                                      role_value: roleValue,
                                      tooltip_toggle: toolTipToggle,
                                      debug_switch: switchChange,
                                      prompt_data: basePromptValue,
                                      initial_message: initialMessage,
                                      temprature: sliderValue,
                                      model: modelValue.value,
                                    })
                                  }
                                >
                                  Save
                                </button>
                              </div>
                            </div>
                          </div>
                          {/* <button
                            type="button"
                            className="btn dropdown-toggle"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offCanvasSettingsRight"
                            aria-controls="offCanvasSettingsRight"
                          >
                            <img src={images["setting-chat.svg"]} alt="" />
                          </button> */}
                        </div>
                      </div>
                      {/* <div className="mobile-view">
                        <FilterComponent
                          isMobile={true}
                          headCells={filterMenu}
                          filterOptions={filterOptions}
                          setFilterOption={setFilterOption}
                          filterOption={filterOption}
                          selectedConversationName={selectedConversationName}
                          selectedConversation={selectedConversation}
                          payloadData={payloadData.current}
                          setSelectedOptions={setSelectedOptions}
                          selectedOptions={selectedOptions}
                          selectedLabelOptions={selectedLabelOptions}
                          setSelectedLabelOptions={setSelectedLabelOptions}
                          selectedFilter={selectedFilter}
                          setSelectedFilter={setSelectedFilter}
                          publicKey={siteData?.details?.is_public}
                        />
                      </div> */}
                    </div>
                    <div className="row">
                      <div
                        className={
                          referenceDocument !== ""
                            ? `col-12 col-md-12 col-lg-6 col-xl-6`
                            : "col-12 col-md-12 col-lg-12 col-xl-12"
                        }
                      >
                        <div className="chat-box-main">
                          {/* <Loader isFixed={false} /> */}
                          <div className="chat-box">
                            <div
                              className={`cnv-box ${
                                loading.current ||
                                loadingPropmptData.length <= 0
                                  ? "regenerate-cnv-box "
                                  : "generate-rs-btn"
                              } pt-0`}
                            >
                              <div className="d-flex align-items-top my-chat">
                                <div className="flex-shrink-0">
                                  <span className="my-pic">
                                    {" "}
                                    <img
                                      src={images["chatbot_logo.svg"]}
                                      alt=""
                                    />
                                  </span>
                                </div>
                                <div className="d-flex ms-3 align-items-center">
                                  <span>
                                    {loadingPropmptData.length === 0
                                      ? siteData?.details?.project_setting
                                          ?.initial_message
                                      : oldConversationInitialMessage}
                                  </span>
                                </div>
                              </div>
                              {loadingPropmptData.length !== 0 &&
                                loadingPropmptData.map((_data, _idx) => {
                                  return (
                                    <>
                                      <div className="d-flex align-items-top other-chat">
                                        <div className="flex-shrink-0">
                                          <span className="other-pic">
                                            {" "}
                                            <img
                                              src={images["user.svg"]}
                                              alt=""
                                            />
                                          </span>
                                        </div>
                                        <div className="flex-grow-1 ms-3 chat-disc">
                                          <p
                                            dangerouslySetInnerHTML={{
                                              __html: _data.question.replace(
                                                /\n/g,
                                                "<br>"
                                              ),
                                            }}
                                          ></p>
                                        </div>
                                      </div>

                                      <div
                                        className="d-flex align-items-top my-chat"
                                        ref={bottom}
                                      >
                                        <div className="flex-shrink-0">
                                          <span className="my-pic">
                                            {" "}
                                            <img
                                              src={images["chatbot_logo.svg"]}
                                              alt=""
                                            />
                                          </span>
                                        </div>
                                        <div className="flex-grow-1 ms-3  chat-disc">
                                          {_data.answer !== "" &&
                                            _data?.optionalAnswer1 !== false &&
                                            _data?.optionalAnswer1 !==
                                              undefined && (
                                              <>
                                                <div className="ld-blok">
                                                  <button
                                                    type="button"
                                                    className={`btn like-link ${
                                                      _data.like === 1
                                                        ? "like-selected"
                                                        : ""
                                                    }`}
                                                    onClick={() =>
                                                      handleAnswerResponse(
                                                        _data.questionId,
                                                        1
                                                      )
                                                    }
                                                    value={_data.like ? 1 : 2}
                                                  >
                                                    <img
                                                      src={
                                                        images["like-chat.svg"]
                                                      }
                                                      alt=""
                                                    />
                                                  </button>
                                                  <button
                                                    type="button"
                                                    className={`btn like-link ${
                                                      _data.like === 2
                                                        ? "like-selected"
                                                        : ""
                                                    }`}
                                                    onClick={() =>
                                                      handleAnswerResponse(
                                                        _data.questionId,
                                                        2
                                                      )
                                                    }
                                                    value={
                                                      _data.like === 2 ? 2 : 1
                                                    }
                                                  >
                                                    <img
                                                      src={
                                                        images[
                                                          "dislike-chat.svg"
                                                        ]
                                                      }
                                                      alt=""
                                                    />
                                                  </button>
                                                </div>
                                                <div
                                                  className="main-chat-tool"
                                                  key={_data.questionId}
                                                >
                                                  <div className="chattooltip">
                                                    {/* <button
                                                    type="button"
                                                    className="btn p-0 source-btn"
                                                    onClick={() =>
                                                      toggleSourceData(
                                                        _data.questionId
                                                      )
                                                    }
                                                  >
                                                    <img
                                                      src={images["source_2.svg"]}
                                                      className="source-icon"
                                                    />
                                                  </button> */}
                                                    {_data?.optionalAnswer1 !==
                                                      false &&
                                                      _data?.optionalAnswer1 !==
                                                        undefined && (
                                                        <button
                                                          ref={target}
                                                          type="button"
                                                          id={_data.questionId}
                                                          className="btn copy-icon"
                                                          onClick={() => {
                                                            CopyDataToClipboard(
                                                              _data.questionId +
                                                                _idx
                                                            );
                                                            setShow(
                                                              _data.questionId
                                                            );
                                                          }}
                                                        >
                                                          <img
                                                            src={
                                                              images[
                                                                "copy-icon.svg"
                                                              ]
                                                            }
                                                            alt=""
                                                            className="doc-icon"
                                                          />
                                                          <div
                                                            className={
                                                              show !==
                                                              _data.questionId
                                                                ? `chat-tooltip-inner d-none`
                                                                : `chat-tooltip-inner `
                                                            }
                                                          >
                                                            copied!!
                                                          </div>
                                                        </button>
                                                      )}
                                                  </div>
                                                </div>
                                              </>
                                            )}
                                          {_data.loading ? (
                                            <div className="send-icon-loading">
                                              <span className="loading-span">
                                                {
                                                  getRandomText[
                                                    Math.floor(
                                                      Math.random() *
                                                        getRandomText.length
                                                    )
                                                  ]
                                                }{" "}
                                                <div className="dot-loader">
                                                  <div className="dot-flashing"></div>
                                                </div>
                                              </span>
                                            </div>
                                          ) : (
                                            <>
                                              {console.log(
                                                _data.errorData,
                                                "_data.errorData"
                                              )}
                                              {_data.answer !== "" &&
                                              (_data.errorData === "" ||
                                                _data.errorData === null ||
                                                _data.errorData ===
                                                  undefined) ? (
                                                <div
                                                  id={_data.questionId + _idx}
                                                >
                                                  <ReactMarkdown
                                                    linkTarget="_blank"
                                                    remarkPlugins={[gfm]}
                                                  >
                                                    {preprocessMarkdown(
                                                      _data.answer
                                                    )}
                                                  </ReactMarkdown>
                                                </div>
                                              ) : (
                                                // <span
                                                //   dangerouslySetInnerHTML={{
                                                //     __html: _data.answer,
                                                //   }}
                                                // />
                                                <span
                                                  className="text-danger"
                                                  dangerouslySetInnerHTML={{
                                                    __html: _data.errorData,
                                                  }}
                                                />
                                              )}
                                            </>
                                          )}
                                          {_data.answer !== "" &&
                                            _data?.optionalAnswer1 !== false &&
                                            _data?.optionalAnswer1 !==
                                              undefined && (
                                              <div className="chat-bottom">
                                                {_data.optionalAnswer1[0]
                                                  .fileName !== "" &&
                                                  _data.optionalAnswer1[0]
                                                    .fileURL !== null && (
                                                    <h5>Source </h5>
                                                  )}
                                                <ul className="chat-doc-row">
                                                  {_data?.optionalAnswer1 !==
                                                    false &&
                                                    _data?.optionalAnswer1 !==
                                                      undefined &&
                                                    _data?.optionalAnswer1
                                                      .length !== 0 &&
                                                    _data?.optionalAnswer1.map(
                                                      (_sourceData, _idx) => (
                                                        <>
                                                          {_sourceData?.fileName !==
                                                            "" &&
                                                            _sourceData.fileURL !==
                                                              null && (
                                                              <li>
                                                                <span
                                                                  className="chat-doc"
                                                                  target={
                                                                    "_blank"
                                                                  }
                                                                  onClick={() => {
                                                                    if (
                                                                      !_sourceData?.sourceURL
                                                                    ) {
                                                                      setReferenceDocument(
                                                                        _sourceData?.fileURL
                                                                      );
                                                                      setDocumentPageNumber(
                                                                        _sourceData?.pageNumber
                                                                      );
                                                                      setDocumentType(
                                                                        _sourceData?.docType
                                                                      );
                                                                    } else {
                                                                      window.open(
                                                                        _sourceData?.sourceURL
                                                                      );
                                                                    }
                                                                  }}
                                                                >
                                                                  <img
                                                                    src={
                                                                      images[
                                                                        "chat-doc.svg"
                                                                      ]
                                                                    }
                                                                    alt=""
                                                                    className="doc-icon"
                                                                  />{" "}
                                                                  {
                                                                    _sourceData?.fileTitle
                                                                  }
                                                                  {_sourceData?.sourceURL && (
                                                                    <img
                                                                      src={
                                                                        images[
                                                                          "redirect.svg"
                                                                        ]
                                                                      }
                                                                      height={9}
                                                                      width={9}
                                                                      alt=""
                                                                      className="doc-icon ms-1"
                                                                    />
                                                                  )}
                                                                  {_sourceData?.summary &&
                                                                    toolTipToggle && (
                                                                      <span className="tooltip-doc">
                                                                        <span className="tooltip-block">
                                                                          {/* <h3>
                                                                    Summary
                                                                  </h3> */}
                                                                          <p>
                                                                            {
                                                                              _sourceData?.summary
                                                                            }
                                                                          </p>
                                                                        </span>
                                                                      </span>
                                                                    )}
                                                                </span>
                                                              </li>
                                                            )}
                                                        </>
                                                      )
                                                    )}
                                                </ul>
                                              </div>
                                            )}

                                          {(location === "true" ||
                                            switchChange) &&
                                            _data.answer && (
                                              <>
                                                <hr />
                                                <h5>Prompt</h5>

                                                <p
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      _data.preparedPrompt?.replaceAll(
                                                        "\n",
                                                        "<br/>"
                                                      ) ?? "",
                                                  }}
                                                />

                                                {/* {_data?.optionalAnswer1 !==
                                                  false &&
                                                  _data?.optionalAnswer1 !==
                                                    undefined &&
                                                  _data?.optionalAnswer1
                                                    .length !== 0 &&
                                                  _data?.optionalAnswer1.map(
                                                    (_debugData, _idx) => (
                                                      <>
                                                        <hr />
                                                        <h5 className="mt-2">
                                                          Response {_idx + 1}
                                                        </h5>
                                                        <span
                                                          dangerouslySetInnerHTML={{
                                                            __html:
                                                              setDebugData(
                                                                _debugData.matchedContent?.replaceAll(
                                                                  "\n",
                                                                  "<br/>"
                                                                )
                                                              ) ?? "",
                                                          }}
                                                        />
                                                        <br />
                                                        <br />{" "}
                                                        <span>
                                                          Similarity score:
                                                          {
                                                            _debugData?.certainty
                                                          }
                                                        </span>
                                                        <br />
                                                        <span>
                                                          Page number:
                                                          {
                                                            _debugData?.pageNumber
                                                          }
                                                        </span>
                                                      </>
                                                    )
                                                  )} */}
                                              </>
                                            )}
                                        </div>
                                        <br />
                                        <hr />
                                      </div>
                                    </>
                                  );
                                })}
                            </div>

                            <div className="chat-form">
                              {!loading.current &&
                                loadingPropmptData[
                                  loadingPropmptData.length - 1
                                ] && (
                                  <div className="d-flex justify-content-end align-items-center mt-2 p-3">
                                    <button
                                      className="btn btn-primary-md"
                                      onClick={() => handleFaqSend("", true)}
                                    >
                                      Regenerate response
                                    </button>
                                  </div>
                                )}
                              <ChatPageFooter
                                setReferenceDocument={setReferenceDocument}
                                initialMessage={initialMessage}
                                loadingPropmptData={loadingPropmptData}
                                handleFaqSend={handleFaqSend}
                                setInputtedQuestion={setInputtedQuestion}
                                inputedQuestion={inputedQuestion}
                                loading={loading}
                                setTypeOfAnswer={setTypeOfAnswer}
                                scrollToBottom={scrollToBottom}
                                payloadData={payloadData.current}
                                setBasePrompt={setBasePrompt}
                                setSelectedTone={setSelectedTone}
                                basePrompt={basePrompt}
                                selectedTone={selectedTone}
                                selectedConversation={
                                  selectedConversation
                                }
                                UpdateData={UpdateData}

                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          referenceDocument !== "" &&
                          `col-12 col-md-12 col-lg-6 col-xl-6 doc-prv-col`
                        }
                      >
                        {referenceDocument && documentType === "doc" && (
                          <>
                            <button
                              type="button"
                              className="btn btn-close prv-cancel-btn text-right"
                              onClick={() => {
                                setReferenceDocument("");
                                setDocumentPageNumber(0);
                              }}
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>

                            <div className="rpv-core__viewer  p-0">
                              <div className="prev-tools">
                                <Toolbar />
                              </div>
                              <div className="prev-scroll">
                                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.3.122/build/pdf.worker.min.js">
                                  <Viewer
                                    initialPage={documentPageNumber - 1}
                                    fileUrl={referenceDocument}
                                    plugins={[toolbarPluginInstance]}
                                  />
                                </Worker>
                              </div>
                            </div>
                          </>
                        )}
                        {referenceDocument && documentType === "text" && (
                          <>
                            <button
                              type="button"
                              className="btn btn-close prv-cancel-btn text-right"
                              onClick={() => {
                                setReferenceDocument("");
                                setDocumentPageNumber(0);
                              }}
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                            <div
                              className="rpv-core__viewer"
                              dangerouslySetInnerHTML={{ __html: html }}
                            ></div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Play Role Popup */}
            <div
              className="modal fade"
              id="infoModal"
              tabIndex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered common-modal info-modal">
                <div className="modal-content">
                  <div className="modal-header">
                    <h1 className="modal-title fs-5" id="staticBackdropLabel">
                      How to Use the Query Persona/Query Role Setting
                    </h1>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="info-scroll">
                      <p>
                        The Query Persona/Query Role setting allows you to
                        specify the role or persona that you want to use when
                        asking a question to the OpenAI chatbot. This can help
                        the chatbot generate more relevant and personalized
                        responses based on your specific context.
                      </p>
                      <p>
                        Some examples of personas or roles that you might use
                        include "Vehicle Owner," "Professional Mechanic,"
                        "Novice DIYer," "Sales Representative," "Insurance
                        Agent," and "Car Enthusiast." Each persona can provide
                        unique insights and expertise that can help generate
                        more accurate and relevant responses.
                      </p>
                      <p>
                        To use this setting, simply enter a persona or role that
                        you think would be relevant to your question in the
                        input box provided. You can experiment with different
                        personas to find the one that works best for your needs.
                      </p>
                      <p>
                        Remember, providing a persona or role can help the
                        chatbot generate better responses based on your specific
                        context, so be sure to use this setting whenever
                        possible.
                      </p>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-primary-md"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* Tones Popup */}
            <div
              className="modal fade"
              id="tonesModal"
              tabIndex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered common-modal info-modal">
                <div className="modal-content">
                  <div className="modal-header">
                    <h1 className="modal-title fs-5" id="staticBackdropLabel">
                      Tones
                    </h1>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="info-scroll">
                      <div className="tones-block">
                        <h3>Professional</h3>
                        <p>
                          A formal and objective tone often used in business
                          writing, academic writing, and other formal settings.
                        </p>
                        <p>
                          <b>Example:</b> "Dear Sir/Madam, I am writing to
                          inquire about the current job opportunities available
                          at your company. I have attached my resume for your
                          review and consideration."
                        </p>
                      </div>
                      <div className="tones-block">
                        <h3>Casual</h3>
                        <p>
                          An informal and friendly tone often used in
                          conversation, texting, and other informal settings.
                        </p>
                        <p>
                          <b>Example:</b> "Hey there! How's it going? What have
                          you been up to lately?"
                        </p>
                      </div>
                      <div className="tones-block">
                        <h3>Enthusiastic</h3>
                        <p>
                          An energetic and passionate tone often used to convey
                          excitement, positivity, and enthusiasm.
                        </p>
                        <p>
                          <b>Example:</b> "Wow! This is amazing! I can't believe
                          how much fun we had last night!"
                        </p>
                      </div>
                      <div className="tones-block">
                        <h3>Informational</h3>
                        <p>
                          A neutral and straightforward tone often used to
                          convey information, facts, and data in a clear and
                          concise manner.
                        </p>
                        <p>
                          <b>Example:</b> "According to the latest data from the
                          World Health Organization, the number of confirmed
                          cases of COVID-19 has reached over 100 million
                          worldwide."
                        </p>
                      </div>
                      <div className="tones-block">
                        <h3>Funny</h3>
                        <p>
                          A lighthearted and humorous tone often used to make
                          people laugh or to add a touch of humor to a
                          conversation.
                        </p>
                        <p>
                          <b>Example:</b> "Why did the tomato turn red? Because
                          it saw the salad dressing!"
                        </p>
                      </div>
                      <div className="tones-block">
                        <h3>Conversational</h3>
                        <p>
                          A tone designed to mimic the way people speak in
                          conversation, often used in chatbots, customer service
                          interactions, and other contexts where a more natural,
                          conversational tone is desired.
                        </p>
                        <p>
                          <b>Example:</b> "Hi there! How can I help you today?"
                        </p>
                      </div>
                      <div className="tones-block">
                        <h3>Persuasive</h3>
                        <p>
                          A tone used to convince or influence the reader to
                          take a particular action or hold a certain belief,
                          often used in advertising, political writing, and
                          other contexts where the goal is to persuade.
                        </p>
                        <p>
                          <b>Example:</b> "Join our movement today and help make
                          a difference in your community."
                        </p>
                      </div>
                      <div className="tones-block">
                        <h3>Sarcastic</h3>
                        <p>
                          A tone characterized by irony, humor, and a slight
                          edge, often used to express humor, but can also be
                          used to criticize or mock something in a subtle way.
                        </p>
                        <p>
                          <b>Example:</b> "Oh, great. Another meeting. Just what
                          I needed today."
                        </p>
                      </div>
                      <div className="tones-block">
                        <h3>Inspirational</h3>
                        <p>
                          A positive and uplifting tone often used to inspire or
                          encourage the reader to take action or to make a
                          change.
                        </p>
                        <p>
                          <b>Example:</b> "Believe in yourself and all that you
                          are. Know that there is something inside you that is
                          greater than any obstacle."
                        </p>
                      </div>
                      <div className="tones-block">
                        <h3>Emotional</h3>
                        <p>
                          A tone designed to elicit an emotional response from
                          the reader, such as empathy, sadness, anger, or joy,
                          often used in storytelling, memoir writing, and other
                          contexts where the goal is to connect with the reader
                          on an emotional level.
                        </p>
                        <p>
                          <b>Example:</b> "She looked out the window and
                          remembered all the happy times they had shared in that
                          little house by the lake."
                        </p>
                      </div>
                      <div className="tones-block">
                        <h3>Factual</h3>
                        <p>
                          A tone characterized by an emphasis on accuracy,
                          objectivity, and concrete information, often used in
                          journalism, scientific writing, and other contexts
                          where the goal is to convey information in a
                          straightforward and credible manner.
                        </p>
                        <p>
                          <b>Example:</b> "The Earth is the third planet from
                          the Sun and is the only known planet to harbor life."
                        </p>
                      </div>
                      <div className="tones-block">
                        <h3>Creative</h3>
                        <p>
                          A tone characterized by imagination, originality, and
                          artistic expression, often used in fiction writing,
                          poetry, and other forms of artistic expression where
                          the goal is to engage the reader's imagination and
                          evoke emotional responses.
                        </p>
                        <p>
                          <b>Example:</b> "The moon was a ghostly galleon tossed
                          upon cloudy seas."
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-primary-md">
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <ShareDocumentModal
        setDocumentLink={setDocumentLink}
        documentLink={documentLink}
        isOpen={showModal}
        toggle={() => setShowModal(false)}
        project_slug_name={demo}
        source={source}
        typeOfAnswer={typeOfAnswer}
        lengthValue={lengthValue}
        responseTone={responseTone}
      />
    </div>
  );
};
export default ChatPage;

// https://docs.google.com/viewer?url=https://d3ectw1fovuss2.cloudfront.net/public/qa/1670493943573.pdf&embedded=true
